import React from 'react';
import UploadView from '../../components/UploadView/UploadView';

import '../DownloadPage/DownloadPage.css';

export default function UploadPage() {
  return (
    <div className="download-page">
      <div className="download-page-title">Upload</div>
      <div className="download-options">
        <div className="download-NBL">
          <UploadView />
        </div>
      </div>
    </div>
  );
}
